var path = 'directives/displayFile.html';
var html = "<div class=displayFile> <ng-transclude></ng-transclude> <span class=displayFile__icon data-ng-switch=file.type> <i class=\"fa fa-file-pdf-o fa-5x\" data-ng-switch-when=application/pdf></i> <i class=\"fa fa-file-o fa-5x\" data-ng-switch-default></i> </span> <p class=displayFile__name> {{file.name}} </p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/displayFile.html
// module id = c6u2
// module chunks = 1 2